import { createContext } from 'react';

/** The campaign minimum clip length, for review tables that only receive their rows. */
export const MinClipDurationContext = createContext<number | null>(null);
